import { hasCapability, type User } from "../base";

export const externalContractor = {
  read: (user: User) => hasCapability(user, "externalContractor.read"),
  update: (user: User) => hasCapability(user, "externalContractor.update"),
};
